// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$(document).ready(function () {
		$("#rooms option").append(" Bedrooms");
		//Call function with browser is resized.
		$(window).resize(function (event) {
			//resizeWindow();
		});
		//resizeWindow();

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        //var currentDate = new Date();
		$( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: new Date(),
			setDate: new Date(),
			//setDate: new Date(),
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 1);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		//$("#CheckIn").datepicker("setDate", new Date());
		//var currentDatePlus = new Date() + 2;
		//$("#CheckIn").datepicker("setDate", currentDate);
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});
		//$("#CheckOut").datepicker("setDate", currentDate);

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		$(".footer .signup-btn").appendTo('.footer .gdpr-wrap');

		$('.gallery-block__list').slick({
			slide: ".gallery-block__image",
			mobileFirst:true,
			appendArrows:".arrowsHolder",
			slidesToShow: 1,
			slidesToScroll: 1,
			accessibility: false,
			responsive: [
				{
				  breakpoint: 1200,
				  settings: "unslick"
				},
				{
					breakpoint: 600,
                	settings: "unslick"
				}
				// You can unslick at a given breakpoint now by adding:
				// settings: "unslick"
				// instead of a settings object
			  ]
		})


		$('.items-slider-items').slick({
			slidesToShow:3,
			infinite:true, 
			dots:true,
			responsive: [
				{
					breakpoint: 800,
					settings: {
					  slidesToShow: 3,
					  slidesToScroll: 1
					}
				},
				{
				  breakpoint: 480,
				  settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				  }
				}
				// You can unslick at a given breakpoint now by adding:
				// settings: "unslick"
				// instead of a settings object
			  ]
		})

		$('.toggle-venues').on('click', function(){
			$(this).addClass('active');
			$(this).siblings().removeClass('active');
			var dataTarget = $(this).data('tag');
			switch(dataTarget){
				case "chart-view":
					$('#chart-view').show();
					$('#list-view').hide();
				break;
				case "list-view":
					$('#list-view').show();
					$('#chart-view').hide();
				break;
			}

		})
		
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};
	//Gallery
	if(document.querySelector("body").classList.contains("gallery") || document.querySelector("body").classList.contains("explore-prescott") || document.querySelector("body").classList.contains("sitemap")){
		let logo =  document.getElementById('img-logo');
		logo.src = "/assets/images/logo-color.png";
	}

	//Fanycbox
	$('[data-caption]').fancybox({
		btnTpl:{
			arrowLeft:
			'<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
			"</button>",

			arrowRight:
				'<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
				"</button>",
			smallBtn : '<div data-fancybox-close class="fancybox-close-small modal-close"></div>'
		},
		toolbar: false,
        infobar: false,
        smallBtn : true
	})
	$('[data-menus]').fancybox({
		slideClass: "fancy-menus",
		btnTpl:{
			smallBtn : '<div data-fancybox-close class="fancybox-close-small modal-close"></div>'
		},
		touch: {
			vertical: false,
			momentum: true // Continue movement after releasing mouse/touch when panning
		}
	})
	$('[data-fancybox]').fancybox({
		btnTpl:{
			smallBtn : '<div data-fancybox-close class="fancybox-close-small modal-close"></div>'
		}
	})


}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	let logo =  document.getElementById('img-logo');
	let logoColor = "/assets/images/logo-color.png";
	let logoWhite = "/assets/images/logo.png";

	let btnBook =  document.querySelector("#booking-down");

	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
				logo.src = logoColor;
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
			logo.src = logoWhite;
			//Gallery
			if(document.querySelector("body").classList.contains("gallery")|| document.querySelector("body").classList.contains("explore-prescott") || document.querySelector("body").classList.contains("sitemap")){
				let logo =  document.getElementById('img-logo');
				logo.src = "/assets/images/logo-color.png";
			}
		}
	}
	if(st >885){
		btnBook.classList.add('active')
	}else{
		btnBook.classList.remove('active')
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

	let jsMenu = document.querySelector('.js-menu');
	let menuBlock =  document.querySelector('.menu-block');
	let closeMenu =  document.querySelector('.js-close');
	jsMenu.addEventListener('click', function(e){
		menuBlock.classList.add('active');
		e.preventDefault();
	})
	closeMenu.addEventListener('click', function(e){
		menuBlock.classList.remove('active');
		e.preventDefault();
	})
}